var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "a",
    { staticClass: "col-sm-6 col-md-4 col-lg-3", attrs: { href: _vm.url } },
    [
      _c(
        "b-card",
        { staticClass: "h-100", attrs: { "no-body": "" } },
        [
          _c(
            "b-card-body",
            [
              _c(
                "b-row",
                {
                  staticClass: "h-100",
                  attrs: { "align-v": "center", "align-h": "center" },
                },
                _vm._l(_vm.range.select_mouldings, function (moulding) {
                  return _c(
                    "b-col",
                    {
                      key: moulding.sku,
                      staticClass: "text-center",
                      class: {
                        "col-12": _vm.range.select_mouldings.length === 1,
                      },
                      attrs: { cols: "6" },
                    },
                    [
                      _c("b-img-lazy", {
                        staticClass: "range-mld my-1",
                        attrs: {
                          src: `/images/picture-frame-chevrons/${moulding.itemCode}/300.jpg`,
                        },
                      }),
                    ],
                    1
                  )
                }),
                1
              ),
            ],
            1
          ),
          _c("b-card-footer", [
            _c("h5", { staticClass: "card-title mb-0" }, [
              _vm._v(_vm._s(_vm.range.name)),
              _c("small", [
                _vm._v(
                  "- " +
                    _vm._s(_vm.range.total_mouldings_count) +
                    " moulding" +
                    _vm._s(_vm.range.total_mouldings_count > 1 ? "s" : "")
                ),
              ]),
            ]),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }